var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcnArrowRightBoldUp16 = function SvgIcnArrowRightBoldUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "evenodd",
    d: "M8.793 8a.5.5 0 0 0 .353-.854L6.354 4.354a.5.5 0 0 0-.708 0L2.854 7.146A.5.5 0 0 0 3.207 8z",
    clipRule: "evenodd"
  })));
};
export default SvgIcnArrowRightBoldUp16;